import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

import * as S from "./styles";

interface IKOGIconCloseModalProps {
	handleClose: () => void;
}

function KOGIconCloseModal({ handleClose }: IKOGIconCloseModalProps) {
	return (
		<S.AreaIconCloseModal>
			<IconButton aria-label="close" onClick={handleClose}>
				<CloseIcon />
			</IconButton>
		</S.AreaIconCloseModal>
	);
}

export default KOGIconCloseModal;
